<template>
  <div
    class="c-player__overlay"
    :class="{ 'is-loading': isLoading }"
  >
    <div
      v-if="showSpinner"
      class="o-icon o-icon--buffering c-player__spinner"
    ></div>
    <ui-player-overlay-paused :class="{ 'is-visible': showPauseOverlay }"></ui-player-overlay-paused>
    <div
      class="c-player__container"
      :class="{ 'is-visible': isVisible }"
      @click.self="clickHandler(pause, toggleFullscreen)"
    >
      <ui-player-seasons v-if="showSeasons"></ui-player-seasons>
      <ui-player-options v-if="showOptions"></ui-player-options>
      <ui-title
        v-if="isEmbedded || (!showPauseOverlay && !$window.isMobileView)"
        :is-embedded="isEmbedded"
      ></ui-title>
    </div>
    <ui-player-subtitles></ui-player-subtitles>
    <ui-player-debug-info
      v-if="subscriber.isTester"
      :current-profile="state.currentProfile"
      :current-settings="state.settings"
      :options="state.options"
    ></ui-player-debug-info>
  </div>
</template>
<script>
  import UiPlayerDebugInfo from '@/shared/components/player/components/overlay/components/debug-info/index.vue';
  import UiPlayerSeasons from '@/shared/components/player/components/overlay/components/seasons/index.vue';
  import UiPlayerOptions from '@/shared/components/player/components/overlay/components/options/index.vue';
  import UiTitle from '@/shared/components/player/components/title/index.vue';
  import {
    closeSubOverlays,
    isAnySubOverlayOpen,
    setPlayerStatus,
    state,
  } from '@/shared/components/player/store';
  import { AutoplayStatus, OverlayStatus, PlayerStatus, TimeshiftMode } from '@/shared/components/player/enums';
  import UiPlayerOverlayPaused from '@/shared/components/player/components/overlay/components/paused/index.vue';
  import DblClickMixin from '@/shared/components/player/mixins/dblclick';
  import FullscreenToggleMixin from '@/shared/components/player/mixins/fullscreen-toggle';
  import UiPlayerSubtitles from '@/shared/components/player/components/subtitles/index.vue';

  export default {
    name: 'UiPlayerOverlay',
    components: {
      UiPlayerDebugInfo,
      UiPlayerSubtitles,
      UiPlayerOverlayPaused,
      UiPlayerOptions,
      UiPlayerSeasons,
      UiTitle,
    },
    mixins: [
      DblClickMixin,
      FullscreenToggleMixin,
    ],
    props: {
      isEmbedded: Boolean,
    },
    data() {
      return {
        state,
        subscriber: this.$services.resolve('subscriber'),
      };
    },
    computed: {
      isBuffering() {
        return state.isBuffering || this.isBufferingAdverts;
      },
      playerStatus() {
        return state.playerStatus;
      },
      showSeasons() {
        return state.showSeasons;
      },
      showOptions() {
        return state.showOptions;
      },
      isAutoplayBlocked() {
        return state.autoplayStatus === AutoplayStatus.BLOCKED;
      },
      isPaused() {
        return this.playerStatus === PlayerStatus.PAUSE;
      },
      isLoading() {
        return this.playerStatus === PlayerStatus.LOADING;
      },
      isInteraction() {
        return state.overlayStatus === OverlayStatus.INTERACTION;
      },
      isWaitingInteraction() {
        return this.playerStatus === PlayerStatus.WAITING_INTERACTION;
      },
      isPlayingAdverts() {
        return this.playerStatus === PlayerStatus.ADVERTS_PLAYING;
      },
      isBufferingAdverts() {
        return this.playerStatus === PlayerStatus.ADVERTS_BUFFERING;
      },
      isVisible() {
        if (!this.playerStatus || this.isLoading || this.isPlayingAdverts) {
          return false;
        }

        return this.isInteraction || this.showPauseOverlay;
      },
      showSpinner() {
        if (this.showPauseOverlay) {
          return false;
        }

        return this.isBuffering || this.isLoading;
      },
      showPauseOverlay() {
        return this.isPaused || this.isWaitingInteraction || this.isAutoplayBlocked;
      },
    },
    methods: {
      pause() {
        if (isAnySubOverlayOpen()) {
          closeSubOverlays();
          return;
        }

        if (!state.controlsEnabled) {
          return;
        }

        if (state.timeshiftMode === TimeshiftMode.DISABLED) {
          return;
        }
        setPlayerStatus(PlayerStatus.PAUSE);
      },
    },
  };
</script>
